export default __webpack_public_path__ + "static/media/hilden_2_light.ff7461f7.png";